import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Branch_Gst_Verification_URL } from "../Url";
export const branchGSTVerificationActions = {
  FETCH_BRANCH_GST_VERIFICATION_LIST: "FETCH_BRANCH_GST_VERIFICATION_LIST",
  FETCH_BRANCH_GST_VERIFICATION_LIST_SUCCESS:
    "FETCH_BRANCH_GST_VERIFICATION_LIST_SUCCESS",
  FETCH_BRANCH_GST_VERIFICATION_LIST_ERROR:
    "FETCH_BRANCH_GST_VERIFICATION_LIST_ERROR",
};

export function saveBranchGSTVerificationDetails(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Gst_Verification_URL}/partnerBranchGSTVerification`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchGSTVerificationDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchGSTVerificationDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchGSTVerificationDetailsError(err));
          return err.response;
        }
      });
}
export function getBranchGSTVerificationDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: branchGSTVerificationActions.FETCH_BRANCH_GST_VERIFICATION_LIST_SUCCESS,
      payload: props,
    });
  };
}
export function getBranchGSTVerificationDetailsError(error) {
  return {
    type: branchGSTVerificationActions.FETCH_BRANCH_GST_VERIFICATION_LIST_ERROR,
    payload: error,
  };
}

export const branchGSTGetActions = {
  FETCH_BRANCH_GST_GET_LIST: "FETCH_BRANCH_GST_VERIFICATION_LIST",
  FETCH_BRANCH_GST_GET_LIST_SUCCESS:
    "FETCH_BRANCH_GST_VERIFICATION_LIST_SUCCESS",
  FETCH_BRANCH_GST_GET_LIST_ERROR: "FETCH_BRANCH_GST_VERIFICATION_LIST_ERROR",
};

export function getBranchGSTVerificationDetails(props) {
  const { access_token, partnerFirmId, partnerBranchId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Gst_Verification_URL}/getGSTDetailsByPartnerBranchId?partnerBranchId=${partnerBranchId}&partnerFirmId=${partnerFirmId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(BranchGSTGetDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchGSTGetDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchGSTGetDetailsError(err));
          return err.response;
        }
      });
}
export function BranchGSTGetDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: branchGSTGetActions.FETCH_BRANCH_GST_GET_LIST_SUCCESS,
      payload: props,
    });
  };
}
export function getBranchGSTGetDetailsError(error) {
  return {
    type: branchGSTGetActions.FETCH_BRANCH_GST_GET_LIST_ERROR,
    payload: error,
  };
}

export function saveBranchGSTNotAvailable(props) {
  const { access_token, values, BranchId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Gst_Verification_URL}/savePartnerBranchGstNotAvailableFlag?partnerBranchId=${BranchId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);

          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchGSTVerificationDetailsError(err));
          return err.response;
        }
      });
}


